import { IPermissionProps } from "../../models/Login";
import { baseUrl } from "../../shared/Fetch";
import { useEffect, useRef, useState } from "react";
import SalesRank1 from "../../assets/branchRanking/Sales1stRank.jpg";
import SalesRank2 from "../../assets/branchRanking/Sales2ndRank.jpg";
import SalesRank3 from "../../assets/branchRanking/Sales3rdRank.jpg";
import RecruiterRank1 from "../../assets/branchRanking/Rec1stRank.jpg";
import RecruiterRank2 from "../../assets/branchRanking/Rec2ndRank.jpg";
import RecruiterRank3 from "../../assets/branchRanking/Rec3rdRank.jpg";
import { BranchWiseReport } from "../creativityDashboard/BranchWiseReport";



export interface Video {
    id?: string;
    title?: string;
    url?: string;
    description?: string;
    created_at?: Date;
    fileName?: string;
}

export const VideoView = (permissions: IPermissionProps) => {
    const [videos, setVideos] = useState<Video[]>([]);
    // const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [runalert, setAlert] = useState(false)
    // const [innerDialogVisible, setInnerDialogVisible] = useState({ Video: undefined as string | undefined, open: false });
    // const [openAlertBox, setOpenAlertBox] = useState(false)
    // const [openRecBox, setOpenRecBox] = useState(false)
    // const [tableData1, setTableData1] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });

    const runalertRef = useRef(runalert);
    // const dt = useRef<any>(null);

    useEffect(() => {
        runalertRef.current = runalert;
    }, [runalert]);

    let _roles: Array<number> = [];
    const loginObj = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach((role: { role_ID: number }) => {
        _roles.push(role.role_ID);
    });

    const fetchAllVideoUrls = async () => {
        try {
            const response = await fetch(`${baseUrl}Video_gallery/getAllVideoUrls`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}` // Assuming token-based auth
                }
            });
            if (!response.ok) {
                throw new Error('Failed to fetch video URLs');
            }

            const data: Video[] = await response.json();
            return data;
        } catch (err) {
            return null;
        }
    };

    // const PostedDate = ({ createdAt }: { createdAt?: Date }) => {
    //     let date;
    //     if (createdAt) date = format(new Date(createdAt), 'dd/MM/yyyy').toUpperCase();
    //     else date = "";
    //     return <>{date}</>;
    // };

    useEffect(() => {
        const fetchVideos = async () => {
            const data = await fetchAllVideoUrls();
            if (data) {
                setVideos(data);
            }
        };

        fetchVideos();
    }, []);


    // const hideInnerDialog = () => {
    //     // setInnerDialogVisible(false);
    //     setInnerDialogVisible({ Video: undefined, open: false });
    // };

    // const getLastPOPoData = async () => {
    //     const response = await Fetch("Dashboard/LastPODate", "GET", null, null, null);
    //     const data = await response?.json();
    //     console.log(data[0].daysAgo);
    //     if (data[0].daysAgo > 15) {
    //         console.log(1)
    //         setAlert(true);
    //     } else {
    //         console.log(2)
    //         setAlert(false);
    //     }
    // }

    // const loadTableData = async () => {
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("Dashboard/Lastpodetails", "GET", null, null, null);
    //     if (response) {
    //         const data: Array<any> = await response.json();

    //         setTableData({ tableData: data, loading: false });
    //     }
    // }


    // const loadTableData1 = async () => {
    //     setTableData1({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("Dashboard/RecruitersDetails", "GET", null, null, null);
    //     if (response) {
    //         const data: Array<any> = await response.json();

    //         setTableData1({ tableData: data, loading: false });
    //     }
    // }

    // useEffect(() => {
    //     getLastPOPoData();
    // }, []);


    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         getLastPOPoData();
    //         if (_roles.includes(2) && runalert) {
    //             loadTableData();
    //             setOpenAlertBox(true)
    //         } else {
    //             loadTableData1();
    //             setOpenRecBox(true)
    //         }
    //     }, 1000 * 60 * 1); // every 1 minute

    //     return () => clearInterval(interval);
    // }, [runalert]); // Depend on runAlert


    return (
        <>
            {/* <div className="grid">
                {videos.map((video) => (
                    <div key={video.id} className="col-12 md:col-6 xl:col-3 ">
                        <div className="border-1 surface-border border-round m-2 text-center py-2 px-3">

                            <div className="flex flex-row justify-content-between align-items-center gap-1" style={{ width: "100%" }}>
                                <h4 className="text-xl underline" style={{ color: "green", }}>
                                    Uploaded On: <PostedDate createdAt={video.created_at} />
                                </h4>
                                <h4 className="text-xl underline my-1" style={{ color: "red", }}>{video.title}</h4>
                                <h4 className="text-xl underline my-1" style={{ color: "red", }} onClick={() => { setInnerDialogVisible({ Video: video.fileName, open: true }); }} >Click Me</h4>

                            </div>
                            <video width="100%" height="200" controls>
                                    <source src={`${baseUrl}Video_gallery/streamVideo/?fileName=${video.fileName}`} type="video/mp4" />
                                </video>
                         
                            <h4 style={{ color: "blue"}} className="text-2xl my-0 underline">description :  {video.description}</h4>
                        </div>

                    </div>
                ))}
            </div> */}
            {/* <div className="flex flex-row justify-content-between align-items-center gap-3" style={{ width: "100%" }}>
                <div className="flex">
                    <img src={POGraph} style={{ width: "100%" }} alt="rank1" />
                </div>
                <div className="flex">
                    <img src={ECIGraph} style={{ width: "100%" }} alt="rank1" />
                </div>
            </div>
             <div className="flex">
                <video width="100%" height="500" controls >
                    <source src={JobvrittaVideo} type="video/mp4" />
                </video></div>  */}
                 
            <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Team Sales</p>
            <div className="flex flex-row justify-content-between align-items-center mb-3">
                <img src={SalesRank1} style={{ width: "30%" }} alt="rank1" />
                <img src={SalesRank2} style={{ width: "30%" }} alt="rank2" />
                <img src={SalesRank3} style={{ width: "30%" }} alt="rank3" />
            </div>
            <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Team Recruitment</p>
            <div className="flex align-content-center justify-content-between mb-3">
                <img src={RecruiterRank1} style={{ width: "30%" }} alt="rank1" />
                <img src={RecruiterRank2} style={{ width: "30%" }} alt="rank2" />
                <img src={RecruiterRank3} style={{ width: "30%" }} alt="rank3" />
            </div>
            <BranchWiseReport />

            {/* <div className="grid">
                {videos.map((video) => (
                    <div key={video.id} className="col-12 md:col-6 xl:col-3 p-2">
                        <Tag className="widget-overview-box" style={{ background: 'linear-gradient(-225deg, #26C6DA 0%, #79dbe8 48%, #0a84ab 100%)', width: '100%', height: '100%', padding: '20px', borderRadius: '8px' }}>
                            <div className="flex flex-column align-items-center text-center">
                                <h4 className="text-2xl my-2 font-bold underline" style={{ fontSize: "10rem", color: "#B9196A" }}>
                                    Uploaded On: <PostedDate createdAt={video.created_at} />
                                </h4>
                                <h4 className="text-base text-xl my-2 font-bold" style={{ color: "#B9196A" }}>{video.title}</h4>
                                <i className="pi pi-external-link text-xl my-2 hover:text-orange-500" style={{ fontSize: "2rem", color: "blue", cursor: 'pointer', transition: 'color 0.9s' }} onClick={() => { setInnerDialogVisible({ Video: video.fileName, open: true }); }}></i>
                            </div>
                        </Tag>
                    </div>
                ))}
            </div> */}


            {/* 
            <Dialog header="" visible={innerDialogVisible.open} style={{ width: '50vw' }} onHide={hideInnerDialog}>
                <video
                    autoPlay
                    width="100%"
                    height="200"
                    controls
                >
                    <source src={`${baseUrl}Video_gallery/streamVideo/?fileName=${innerDialogVisible.Video}`} type="video/mp4" />
                    <source src={`${baseUrl}Video_gallery/streamVideo/?fileName=${innerDialogVisible.Video}`} type="video/mp4" />

                </video>
                {innerDialogVisible.Video && (
                    <ReactPlayer 
                        url={`${baseUrl}Video_gallery/streamVideo/?fileName=${innerDialogVisible.Video}`} 
                        controls 
                        width="100%" 
                        height="100%" 
                    />
                )}
            </Dialog> */}

            {/* <Dialog visible={openAlertBox} style={{ width: '80vw' }} header="Requirement Posted History" modal className="p-fluid" onHide={() => { setOpenAlertBox(false); }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData.tableData}
                    emptyMessage="No Requirements found."

                    loading={tableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="noOfReq" header="Req.ID" sortable />
                    <Column field="noOfSub" header="Sub" />
                    <Column field="noOfSubClient" header="ECS" />
                    <Column field="noOfECI" header="ECI" />
                    <Column field="po" header="PO" />



                </DataTable>
            </Dialog>
            <Dialog visible={openRecBox} style={{ width: '80vw' }} header="Requirement Posted History" modal className="p-fluid" onHide={() => { setOpenRecBox(false); }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={tableData1.tableData}
                    emptyMessage="No Requirements found."

                    loading={tableData1.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="noOfAllReq" header="Req.ID" sortable />
                    <Column field="noOfSub" header="Sub" />
                    <Column field="noOfSubClient" header="ECS" />
                    <Column field="noOfECI" header="ECI" />
                    <Column field="po" header="PO" />



                </DataTable>
            </Dialog> */}
        </>
    );
}
